
//
// New function wrapping the original one with a promise
//
export function useGetGeoLocationAsync () {
  return new Promise((resolve, reject) => {
    useGetGeoLocation(response => {
      if (response.type === 'success') {
        resolve(response)
      } else {
        reject(response)
      }
    })
  })
}

//
// Get geo location for user
//
export function useGetGeoLocation (callback) {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(
      position => {
        callback({
          type: 'success',
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        })
      },
      error => {
        console.error('Error getting Position from User:', error.message)
        
        callback({
          type: 'error',
          message: error.message
        })
      }
    )
  } else {
    console.error('Geolocation is not available')
    
    callback({
      type: 'error',
      message: 'Geolocation is not available'
    })
  }
}

//
// Calculate the distance between two coordinates using the Haversine Formula
// 
export function useGetDistanceInKm (pos1, pos2) {
  // console.log('useGetDistanceInKm')
  const lon1 = pos1.lng
  const lat1 = pos1.lat
  const lon2 = pos2.lng
  const lat2 = pos2.lat

  const R = 6371 // Radius of the earth in km
  const dLat = (lat2-lat1) * (Math.PI/180)
  const dLon = (lon2-lon1) * (Math.PI/180)
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * (Math.PI/180)) * Math.cos(lat2 * (Math.PI/180)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
  const d = R * c // Distance in km
  
  return d
}
